import { LoadingButton } from "@mui/lab";
import { TextField } from "@mui/material";
import React, { useContext, useState } from "react";
import { httpService } from "../httpService";
import Swal from "sweetalert2";
import { AlertContext } from "../contexts/AlertContext";

export default function DeleteRegistrations() {
  const { setAlertData } = useContext(AlertContext);
  const [instId, setInstID] = useState("");

  const [deleting, setDeleting] = useState(false);
  const deleteRegistration = (e) => {
    e.preventDefault();
    Swal.fire({
      icon: "question",
      title: `Delete Institution ${instId}`,
      text: "Are you sure you want to delete the regsitration of the participant(s) registered with this institution ID?",
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "No don't delete",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setDeleting(true);
        const { data, error } = await httpService.delete(
          `deleteregistration/${instId}`
        );

        if (data) {
          setAlertData({ open: true, message: data, severity: "success" });
        }
        if (error) {
          setAlertData({ open: true, message: error, severity: "error" });
        }

        setDeleting(false);
      }
    });
  };

  return (
    <div>
      <div className="mt-5 mb-5 container">
        <h3>Delete Registrations</h3>

        <form onSubmit={deleteRegistration}>
          <div className="mt-4 mb-4 col-md-4">
            <TextField
              required
              fullWidth
              label="Institution ID"
              onChange={(e) => setInstID(e.target.value)}
            />
          </div>
          <LoadingButton type="submit" loading={deleting} variant="contained">
            Delete this registration
          </LoadingButton>
        </form>
      </div>
    </div>
  );
}
